import React from 'react';
import moment from 'moment';

import { Avatar, MCButton } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { countFormat, lang, remCss, uniqueArray } from 'src/helpers';

import LANG_CONST from 'src/helpers/lang/const';

export class DoctorItem extends BaseComponent {
  render() {
    let {
      temp,
      firstName,
      lastName,
      avatar,
      specialist = [],
      yearOfStarting,
      training,
      doctor,
      onOpenDoctor,
      slots,
      treatmentCount = 0,
      isOnline = false
    } = this.props;
    if (temp) return <div className={'mc-doctor-box'} style={{ visibility: 'hidden' }} />;

    let experience = yearOfStarting ? moment().year() - yearOfStarting + 1 : training;
    if (experience > 0) {
      experience = lang.t(experience > 1 ? LANG_CONST.amount_years : LANG_CONST.amount_year, {
        amount: experience
      });
    }

    return (
      <div className={'mc-doctor-box'}>
        <div className={'mc-flex-col'} style={{ height: '100%' }}>
          <div className={'mc-flex'}>
            <Avatar
              width={100}
              height={100}
              text={`${firstName} ${lastName}`}
              onlineState={isOnline > 0 ? 'online' : ''}
              image={(avatar || '').toString().replace('/full_', '/350_')}
            />
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-value-620'}>{`Dr. ${firstName} ${lastName}`}</div>
              <div className={'mc-label-416'}>
                {specialist
                  .filter((v) => !!LANG_CONST.constants.specialist[v])
                  .map((v) => lang.t(LANG_CONST.constants.specialist[v]))
                  .join(', ')}
              </div>
            </div>
          </div>
          <div className={'mc-flex-20 mc-flex-start'}>
            <div className={'mc-flex-col mc-grow'} style={{ minWidth: 0 }}>
              <div className={'mc-label-416'}>{lang.t(LANG_CONST.location)}</div>
              <div style={{ maxWidth: remCss(250) }}>
                <div className={'mc-value-620 mc-text-truncate'}>
                  {uniqueArray(
                    slots.filter((item) => !!item.hospital),
                    'hospital'
                  )
                    .map((item) => item.hospital?.split('_')[0])
                    ?.join(', ')}
                </div>
              </div>
            </div>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-416'}>{lang.t(LANG_CONST.total_treatments)}</div>
              <div className={'mc-value-620'}>{countFormat(treatmentCount)}</div>
            </div>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-416'}>{lang.t(LANG_CONST.experience)}</div>
              <div className={'mc-value-620'}>{experience}</div>
            </div>
          </div>
          {slots?.length > 0 && (
            <div className={'mc-flex'}>
              <div className={'mc-value-520 mc-grow'}>{lang.t(LANG_CONST.book_available)}</div>
              <div className={'mc-label-420'}>
                {moment(slots[0].startDate).format('MMM DD, YYYY')}
              </div>
            </div>
          )}
          <div className={'mc-times'}>
            {slots
              .filter(
                (slot) =>
                  moment(slot.startDate).format('MMM DD, YYYY') ===
                  moment(slots[0].startDate).format('MMM DD, YYYY')
              )
              .map((slot) => (
                <MCButton
                  small
                  light
                  radius
                  quaternary
                  key={slot.id}
                  onClick={() => onOpenDoctor(doctor, slot)}
                >
                  {moment(slot.startDate).format('h:mm a')}
                </MCButton>
              ))}
          </div>
          <div className={'mc-grow'}></div>
          <div>
            <div className={'mc-more'} onClick={() => onOpenDoctor(doctor)} style={{ margin: 0 }}>
              {lang.t('View more')} →
            </div>
          </div>
        </div>
      </div>
    );
  }
}
